// ynDropzoneEmptyBg / ynTrayBg: fill colors for the DM drag-and-drop Yes/No
// widget's empty drop zones and side tray. Only pearsonDefault is sampled
// from a real harvested screenshot (docs/research/ucat-pearson-vue-harvest/
// sample/uk-pt-a/10-dm-drag-empty.png). The rest are derived — each scheme's
// `body` blended toward its `border`/ink color at roughly the same ratio the
// harvested sample shows between its dropzone-grey and its white body, with
// the tray a lighter blend than the dropzone. Swap for sampled values if/when
// other schemes get harvested captures.
export const COLOR_SCHEMES = {
  ivori:        { label: 'IVORI',                 chrome: '#FFFFFF', body: '#FAF8F5', border: '#D8D2C4', text: '#14161F', ynDropzoneEmptyBg: '#E4DFD3', ynTrayBg: '#EFEBE2' },
  pearsonDefault: { label: 'Color Scheme',        chrome: '#006DAA', body: '#FFFFFF', border: '#084A86', text: '#14161F', ynDropzoneEmptyBg: '#B2A8A8', ynTrayBg: '#DADADA' },
  lightYellow:  { label: 'Black on Light Yellow',  chrome: '#FFF9B0', body: '#FFF9B0', border: '#14161F', text: '#14161F', ynDropzoneEmptyBg: '#D8CE8E', ynTrayBg: '#EDE6B8' },
  salmon:       { label: 'Black on Salmon',        chrome: '#FBDCC8', body: '#FBDCC8', border: '#14161F', text: '#14161F', ynDropzoneEmptyBg: '#D9BCA8', ynTrayBg: '#F0DCC9' },
  white:        { label: 'Black on White',         chrome: '#FFFFFF', body: '#FFFFFF', border: '#14161F', text: '#14161F', ynDropzoneEmptyBg: '#C9C9C9', ynTrayBg: '#E6E6E6' },
  yellow:       { label: 'Black on Yellow',        chrome: '#FFEB00', body: '#FFEB00', border: '#14161F', text: '#14161F', ynDropzoneEmptyBg: '#D6C900', ynTrayBg: '#F0E866' },
  // UCAT official-style high-contrast schemes (dark blue ink)
  blueOnWhite:  { label: 'Blue on White',          chrome: '#FFFFFF', body: '#FFFFFF', border: '#00008B', text: '#00008B', ynDropzoneEmptyBg: '#C7C7E8', ynTrayBg: '#E4E4F5' },
  blueOnYellow: { label: 'Blue on Yellow',         chrome: '#FFFF00', body: '#FFFF00', border: '#00008B', text: '#00008B', ynDropzoneEmptyBg: '#D6D600', ynTrayBg: '#F0F080' },
};

/** Colour schemes shown in UCAT mock / past-paper pre-screens and exam chrome. */
export const UCAT_COLOR_SCHEME_KEYS = [
  'ivori',
  'lightYellow',
  'salmon',
  'blueOnWhite',
  'blueOnYellow',
  'white',
  'yellow',
];

/** Colour schemes shown in TMUA flows (excludes UCAT-only blue ink schemes). */
export const TMUA_COLOR_SCHEME_KEYS = [
  'ivori',
  'lightYellow',
  'salmon',
  'white',
  'yellow',
];

/** Harvest order for the TMUA Pearson-player sitting, plus IVORI. No UCAT blue-ink. */
export const TMUA_PEARSON_COLOR_SCHEME_KEYS = [
  'pearsonDefault',
  'ivori',
  'lightYellow',
  'salmon',
  'white',
  'yellow',
];

/** Spec §3 order for the UCAT Pearson-player sitting — harvest seven plus IVORI. */
export const UCAT_PEARSON_COLOR_SCHEME_KEYS = [
  'pearsonDefault',
  'ivori',
  'lightYellow',
  'salmon',
  'white',
  'yellow',
  'blueOnWhite',
  'blueOnYellow',
];

export function getColorSchemesForExam(examName, options) {
  const upper = String(examName || '').toUpperCase();
  const pearsonPlayer = Boolean(options && options.pearsonPlayer);
  const keys = pearsonPlayer && upper === 'UCAT'
    ? UCAT_PEARSON_COLOR_SCHEME_KEYS
    : pearsonPlayer && (upper === 'TMUA' || upper === 'LNAT' || upper === 'ESAT' || upper === 'TARA')
      ? TMUA_PEARSON_COLOR_SCHEME_KEYS
      : (upper === 'UCAT' ? UCAT_COLOR_SCHEME_KEYS : TMUA_COLOR_SCHEME_KEYS);
  return keys.reduce((acc, key) => {
    if (COLOR_SCHEMES[key]) acc[key] = COLOR_SCHEMES[key];
    return acc;
  }, {});
}

export function getPearsonColorSchemeDropdownLabel(examName) {
  const upper = String(examName || '').toUpperCase();
  return (upper === 'LNAT' || upper === 'UCAT') ? 'Colour Scheme' : 'Color Scheme';
}
